// 🔥 FIXED AttendanceComponent.js - nationality, country, speciality sahi dikhayega ✅

import React, { useState, useEffect, useCallback, useMemo } from "react";
import Dialog from "../../CoreComponent/Dialog";
import httpService from "../../common/httpService";
import toast from "react-hot-toast";
import ImageUpload from "../../CoreComponent/ImageUpload";
import { DataGrid } from "@mui/x-data-grid";
import {
  Typography,
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Paper,
} from "@mui/material";

const YesNoChip = ({ value }) => {
  const yes = value === 1 || value === true || value === "1";
  return (
    <Chip
      size="small"
      label={yes ? "Yes" : "No"}
      color={yes ? "success" : "default"}
      variant={yes ? "filled" : "outlined"}
    />
  );
};

const InfoItem = ({ label, value }) => (
  <Grid item xs={6} sm={4} md={3}>
    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.85rem' }}>
      {value ?? "-"}
    </Typography>
  </Grid>
);

const AttendanceComponent = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [attendanceIdForUpload, setAttendanceIdForUpload] = useState(0);
  const [file, setFile] = useState(null);

  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null);

  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");

  // ✅ FIXED - Original working logic with ALL fallbacks
  const fetchAttendances = useCallback(async (page = 1) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const response = await httpService({
        method: "GET",
        url: "https://eventscons.com/eventbackendnew/api/attendances/paid",
        params: { page },
        headers: { Authorization: `Bearer ${token}` },
        timeout: 10000,
        onSuccess: (data) => {
          console.log("🔍 FULL API RESPONSE:", data);
          
          // ✅ ALL POSSIBLE DATA STRUCTURES
          const list = data?.attendances || 
                       data?.attendance || 
                       data?.data || 
                       data || 
                       [];
          
          console.log("📋 PROCESSED LIST:", list, "Length:", list.length);
          
          setAttendanceData(list);
          setTotalPages(data?.totalPages || data?.last_page || 1);
          setCurrentPage(Number(data?.currentPage || data?.current_page || page));
          
          if (list.length === 0) {
            setErrorMsg("No paid attendances found.");
          } else {
            setErrorMsg("");
          }
        },
        onError: (error) => {
          console.error("❌ API ERROR:", error);
          setErrorMsg("Failed to fetch paid attendance records.");
        },
        withToast: true,
      });
    } catch (error) {
      console.error("❌ CATCH ERROR:", error);
      setErrorMsg("Failed to fetch paid attendance records.");
    } finally {
      setLoading(false);
    }
  }, [token]);

  const handleFileUpload = async () => {
    if (!file) {
      toast.error("Please select a file first");
      return;
    }

    const formData = new FormData();
    formData.append("certificatePDF", file);

    try {
      await httpService({
        method: "POST",
        url: `${BaseUrl}/attendances/${attendanceIdForUpload}/certificate`,
        headers: { Authorization: `Bearer ${token}` },
        data: formData,
        timeout: 10000,
      });
      toast.success("File uploaded successfully!");
      fetchAttendances(currentPage);
    } catch (error) {
      console.error("Failed to upload file:", error);
    }

    setDialogOpen(false);
    setFile(null);
  };

  const handleViewDetails = (row) => {
    setSelectedAttendance(row?.original || null);
    setIsDetailsOpen(true);
  };

  // 🔥 FIXED MAPPING - sahi jagah se data lega
  const rows = useMemo(() => {
    return attendanceData.map((attendance) => {
      console.log("🔍 Processing attendance:", attendance); // Debug
      
      return {
        id: attendance.id,
        conference_title: attendance?.conference?.title || "",
        attendee_name: attendance?.user?.name || "",
        phone: attendance?.user?.phone_number || attendance?.phone_number || "-",
        email: attendance?.user?.email || "",
        
        // 🔥 FIXED - attendance object se fields lenge (registration form se aate hain)
        nationality: attendance?.nationality || 
                    attendance?.user?.nationality || 
                    attendance?.attendance?.nationality || "-",
        
        country: attendance?.country_of_residence || 
                attendance?.user?.country_of_residence || 
                attendance?.attendance?.country_of_residence || "-",
        
        speciality: attendance?.speciality || 
                   attendance?.user?.specialization || 
                   attendance?.speciality || 
                   attendance?.attendance?.speciality || "-",
        
        category: attendance?.category || "",
        hear_about_event: attendance?.hear_about_event || "",
        payment_amount: attendance?.registration_fee || "",
        original: attendance,
      };
    });
  }, [attendanceData]);

  const columns = [
    {
      field: "conference_title",
      headerName: "Conference Name",
      flex: 1.2,
      minWidth: 250,
      sortable: true,
    },
    {
      field: "attendee_name",
      headerName: "Attendee Name",
      flex: 1,
      minWidth: 200,
      sortable: true,
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 0.8,
      minWidth: 160,
    },
    {
      field: "email",
      headerName: "Email Address",
      flex: 1,
      minWidth: 220,
      sortable: true,
    },
    {
      field: "nationality",
      headerName: "Nationality",
      flex: 0.8,
      minWidth: 140,
    },
    {
      field: "country",
      headerName: "Country",
      flex: 0.8,
      minWidth: 140,
    },
    {
      field: "speciality",
      headerName: "Speciality",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 0.9,
      minWidth: 160,
    },
    {
      field: "hear_about_event",
      headerName: "How did you hear?",
      flex: 1.1,
      minWidth: 200,
    },
    {
      field: "view_details",
      headerName: "Actions",
      minWidth: 150,
      flex: 0.7,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleViewDetails(params.row)}
          sx={{ minWidth: 110 }}
        >
          View Details
        </Button>
      ),
    },
  ];

  useEffect(() => {
    fetchAttendances(1);
  }, []);

  if (loading) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <Typography variant="h6" color="primary">
          Loading Complete Attendances...
        </Typography>
      </div>
    );
  }

  return (
    <div
      style={{
        borderRadius: "8px",
        width: "100%",
        maxWidth: "1700px",
        padding: "20px",
      }}
      className="custom-dialog"
    >
      <Typography
        variant="h6"
        sx={{
          color: "#c62828",
          fontWeight: "bold",
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
          textAlign: "center",
        }}
      >
        Complete Attendances
      </Typography>

      {/* ✅ EMPTY STATE */}
      {attendanceData.length === 0 && !loading && errorMsg && (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '300px',
          flexDirection: 'column',
          mt: 4
        }}>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
            {errorMsg}
          </Typography>
          <Button 
            variant="outlined" 
            onClick={() => fetchAttendances(1)}
            sx={{ mt: 1 }}
          >
            Retry
          </Button>
        </Box>
      )}

      <DataGrid
        getRowId={(row) => row.id}
        rows={rows}
        columns={columns}
        paginationModel={{ page: currentPage - 1, pageSize: 12 }}
        onPaginationModelChange={({ page }) => {
          const newPage = page + 1;
          setCurrentPage(newPage);
          fetchAttendances(newPage);
        }}
        rowCount={totalPages * 12}
        pageSizeOptions={[12]}
        paginationMode="server"
        disableCheckboxSelector
        disableRowSelectionOnClick
        loading={loading}
        autoHeight
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        sx={{
          marginTop: "20px",
          "& .MuiDataGrid-virtualScroller": {
            overflow: "hidden !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f5f5f5",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
        }}
      />

      {/* 🔥 FIXED Details Dialog */}
      {isDetailsOpen && selectedAttendance && (
        <Dialog
          viewHeader={true}
          header="Attendance Details"
          open={isDetailsOpen}
          setOpen={setIsDetailsOpen}
          className="dialog-file wide-dialog"
          style={{ maxWidth: '95vw', width: '1200px' }}
        >
          <Box sx={{ p: 1 }}>
            <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
              <Box sx={{ mb: 1.5 }}>
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center', 
                  flexWrap: 'wrap', 
                  gap: 1 
                }}>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography variant="h6" sx={{ fontWeight: 900, fontSize: '1.1rem' }}>
                      {selectedAttendance?.user?.name || selectedAttendance?.name || "-"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                      {selectedAttendance?.user?.email || selectedAttendance?.email || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Chip
                      size="small"
                      label={(selectedAttendance?.payment_status || "UNPAID").toUpperCase()}
                      color={selectedAttendance?.payment_status === "paid" ? "success" : "warning"}
                      sx={{ fontSize: '0.7rem', height: 24 }}
                    />
                  </Box>
                </Box>
              </Box>

              <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1, fontSize: '1rem' }}>
                Registration Details
              </Typography>
              <Grid container spacing={1}>
                <InfoItem label="ID" value={selectedAttendance?.id} />
                <InfoItem label="Phone" value={selectedAttendance?.user?.phone_number || selectedAttendance?.phone_number} />
                <InfoItem label="Nationality" value={selectedAttendance?.nationality || selectedAttendance?.user?.nationality} />
                <InfoItem label="Country" value={selectedAttendance?.country_of_residence || selectedAttendance?.user?.country_of_residence} />
                <InfoItem label="Speciality" value={selectedAttendance?.speciality || selectedAttendance?.user?.specialization} />
                <InfoItem label="Category" value={selectedAttendance?.category} />
                <InfoItem label="Fee" value={`$${selectedAttendance?.registration_fee || '-'}`} />
                <InfoItem label="How heard?" value={selectedAttendance?.hear_about_event} />
              </Grid>

              <Divider sx={{ my: 1.5 }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1, fontSize: '1rem' }}>
                Conference
              </Typography>
              <Grid container spacing={1}>
                <InfoItem label="Title" value={selectedAttendance?.conference?.title} />
                <InfoItem label="Location" value={selectedAttendance?.conference?.location} />
              </Grid>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button variant="outlined" onClick={() => setIsDetailsOpen(false)} size="small">
                  Close
                </Button>
              </Box>
            </Paper>
          </Box>
        </Dialog>
      )}

      {errorMsg && !loading && attendanceData.length === 0 && (
        <Typography variant="body2" color="error" sx={{ marginTop: 2, textAlign: "center" }}>
          {errorMsg}
        </Typography>
      )}
    </div>
  );
};

export default AttendanceComponent;